import apiClient from './base.api'
const BASE_ENDPOINT = window.config.SCHEDULED_BASE_ENDPOINT

export const fetchScheduledMessagesAsync = async() => {
  return await apiClient.get(`${BASE_ENDPOINT}`)
}
export const createScheduledMessageAsync = (payload) => apiClient.post(`${BASE_ENDPOINT}`, payload, { headers: { 'Content-Type': 'multipart/form-data' } })
export const updateScheduledMessageStatusAsync = (id, active) => apiClient.patch(`${BASE_ENDPOINT}${id}/`, { active })
export const updateScheduledMessageAsync = (id, payload) => apiClient.put(`${BASE_ENDPOINT}${id}/`, payload, { headers: { 'Content-Type': 'multipart/form-data' } })
export const deleteScheduledMessageAsync = (id) => apiClient.delete(`${BASE_ENDPOINT}${id}/`)
export const fetchScheduledMessageDetailAsync = (id) => apiClient.get(`${BASE_ENDPOINT}${id}/`)
